<footer class="p-2 text-center" data-test="app-footer">
  <div id="btmFooter">
    <div class="footer-actions">
      <a panButton fill="clear" data-test="mailto-support-link" href="mailto:support@panoptyc.com" target="_blank">Help</a>
      <a href="https://panoptyc.com/policies/terms-of-service" panButton fill="clear" target="_blank" data-test="terms-of-service-link"
        >Terms of Service</a
      >
      <a href="https://panoptyc.com/policies/privacy-policy" panButton fill="clear" target="_blank" data-test="privacy-policy-link"
        >Privacy Policy</a
      >
      <!--    <a href="https://panoptyc.com/policies/refund-policy" mat-button target="_blank">Refund Policy</a>-->
    </div>
    @if (copyright()) {
      <div>Panoptyc, Inc. Micro Market Theft Detection</div>
    }
  </div>
</footer>
